import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import AssigneeOptionContainer from './AssigneeOptionContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const UnassignButtonOption = ({
  currentAssigneeId,
  onClick
}) => /*#__PURE__*/_jsx(Flex, {
  justifyContent: "end",
  paddingBlockEnd: "100",
  children: /*#__PURE__*/_jsx(AssigneeOptionContainer, {
    children: /*#__PURE__*/_jsx(Button, {
      "data-test-id": "reassignment-dropdown-unassign_button",
      disabled: currentAssigneeId === null,
      onClick: onClick,
      paddingBlock: "100",
      paddingInline: "300",
      size: "extra-small",
      use: "tertiary-light",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "routing-ui.reassignment.unassignUserLabel"
      })
    })
  })
});
UnassignButtonOption.displayName = 'UnassignButtonOption';
export default UnassignButtonOption;